export const messagesConstant = {
  hasNoJourneysAccess: 'Only coaching users can access this feature.',
  upgradeErrorMsg: `User's plan does not allow to access this feature`,
  planExpiredErrorMsg: `User's plan has been expired. Please upgrade the plan to access this feature`,
}
